export const PORTAL_GATE_ALERT = 'alert';
